// 用户中心
export const thirdLinkRouter = [
  {
    path: '/thirdLink/index',
    name: 'ThirdLinkIndex',
    component: () => import('../views/thirdLink/index')
},
  // 编辑标签
  {
    path: '/thirdLink/addOrEdit',
    name: 'ThirdLinkAdd',
    component: () => import('../views/thirdLink/add')
}
]